import * as persistenceActionTypes from "../../actions/persistence/persistenceActionTypes";
import {
  BROKER_TYPE,
  PUNI_BROKER_TYPE,
  RETAIL_BROKER_TYPE,
  SURPLUS_BROKER_TYPE,
  EMPTY_PERSON,
  UNDERWRITER_TYPE,
  ASSISTANT_TYPE,
  PRODUCER_BROKER_TYPE,
  WHOLESALE_BROKER_TYPE,
  EMPTY_PUNI_BROKER,
  EMPTY_RETAIL_BROKER,
  EMPTY_WHOLESALE_BROKER,
  EMPTY_PRODUCER_BROKER,
  EMPTY_SURPLUS_BROKER,
} from "domain/people";
import {
  UPDATE_BROKER,
  UPDATE_PREFERRED_UNDERWRITER,
  UPDATE_PREFERRED_UNDERWRITER_NAME,
  UPDATE_PUNI_BROKER,
  UPDATE_RETAIL_BROKER,
  UPDATE_SECONDARY_UNDERWRITER,
  UPDATE_UNDERWRITER_ASSISTANT,
  UPDATE_SURPLUS_BROKER,
  UPDATE_ASSISTANT,
  UPDATE_PRODUCER_BROKER,
  UPDATE_WHOLESALE_BROKER,
  UPDATE_PERSON_BY_TYPE,
} from "store/actions/people/peopleActionTypes";

export const INIT_STATE = {};

const updatePeople = (state, which, type, callback) => {
  const people = (state.people || []).map((person) => ({ ...person }));
  const subgroup = people.filter((p) => p.type === type);
  let person = null;
  if (subgroup.length <= which) {
    while (subgroup.length <= which) {
      person = {
        ...EMPTY_PERSON,
        type: type,
      };
      people.push(person);
      subgroup.push(person);
    }
  } else {
    person = subgroup[which];
  }
  callback(person);
  return {
    ...state,
    people,
  };
};

const updateUnderwriter = (state, which, callback) => {
  return updatePeople(state, which, UNDERWRITER_TYPE, callback);
};

const updatePuniBroker = (state, which, callback) => {
  return updatePeople(state, which, PUNI_BROKER_TYPE, callback);
};

const updateRetailBroker = (state, which, callback) => {
  return updatePeople(state, which, RETAIL_BROKER_TYPE, callback);
};

const updateSurplusBroker = (state, which, callback) => {
  return updatePeople(state, which, SURPLUS_BROKER_TYPE, callback);
};

const updateProducerBroker = (state, which, callback) => {
  return updatePeople(state, which, PRODUCER_BROKER_TYPE, callback);
};

const updateWholesaleBroker = (state, which, callback) => {
  return updatePeople(state, which, WHOLESALE_BROKER_TYPE, callback);
};

const updateBroker = (state, which, callback) => {
  return updatePeople(state, which, BROKER_TYPE, callback);
};

const updateAssistant = (state, which, callback) => {
  return updatePeople(state, which, ASSISTANT_TYPE, callback);
};

const peopleReducer = (state, action) => {
  if (state === undefined) {
    state = {
      ...INIT_STATE,
    };
  }
  switch (action.type) {
    case UPDATE_PREFERRED_UNDERWRITER:
      return updateUnderwriter(state, 0, (underwriter) => {
        if (
          !action.payload ||
          (!action.payload.name && !action.payload.id && !action.payload.email)
        ) {
          underwriter.name = EMPTY_PERSON.name;
          underwriter.id = EMPTY_PERSON.id;
          underwriter.email = EMPTY_PERSON.email;
          underwriter.company = EMPTY_PERSON.company;
        } else {
          underwriter.name = action.payload?.name ?? underwriter.name;
          underwriter.id = action.payload?.id ?? underwriter.id;
          underwriter.email = action.payload?.email ?? underwriter.email;
        }
      });
    case UPDATE_PREFERRED_UNDERWRITER_NAME:
      return updateUnderwriter(state, 0, (underwriter) => {
        underwriter.name = action.payload ?? EMPTY_PERSON.name;
      });
    case UPDATE_SECONDARY_UNDERWRITER:
      return updateUnderwriter(state, 1, (underwriter) => {
        underwriter.name = action.payload?.name ?? EMPTY_PERSON.name;
        underwriter.id = action.payload?.id ?? EMPTY_PERSON.id;
        underwriter.email = action.payload?.email ?? EMPTY_PERSON.email;
      });
    case UPDATE_UNDERWRITER_ASSISTANT:
      return updateUnderwriter(state, 2, (underwriter) => {
        underwriter.name = action.payload?.name ?? EMPTY_PERSON.name;
        underwriter.id = action.payload?.id ?? EMPTY_PERSON.id;
        underwriter.email = action.payload?.email ?? EMPTY_PERSON.email;
      });
    case UPDATE_PUNI_BROKER:
      return updatePuniBroker(state, 0, (broker) => {
        broker.id = action.payload?.id ?? EMPTY_PUNI_BROKER.id;
        broker.name = action.payload?.name ?? EMPTY_PUNI_BROKER.name;
        broker.email = action.payload?.email ?? EMPTY_PUNI_BROKER.email;
        broker.company = action.payload?.company ?? EMPTY_PUNI_BROKER.company;
        broker.licenseNumber =
          action.payload?.licenseNumber ?? EMPTY_PUNI_BROKER.licenseNumber;
      });
    case UPDATE_RETAIL_BROKER:
      return updateRetailBroker(state, 0, (broker) => {
        broker.id = action.payload?.id ?? EMPTY_RETAIL_BROKER.id;
        broker.name = action.payload?.name ?? EMPTY_RETAIL_BROKER.name;
        broker.email = action.payload?.email ?? EMPTY_RETAIL_BROKER.email;
        broker.company = action.payload?.company ?? EMPTY_RETAIL_BROKER.company;
        broker.licenseNumber =
          action.payload?.licenseNumber ?? EMPTY_RETAIL_BROKER.licenseNumber;
      });
    case UPDATE_SURPLUS_BROKER:
      return updateSurplusBroker(state, 0, (broker) => {
        broker.id = action.payload?.id ?? EMPTY_SURPLUS_BROKER.id;
        broker.name = action.payload?.name ?? EMPTY_SURPLUS_BROKER.name;
        broker.email = action.payload?.email ?? EMPTY_SURPLUS_BROKER.email;
        broker.company =
          action.payload?.company ?? EMPTY_SURPLUS_BROKER.company;
        broker.licenseNumber =
          action.payload?.licenseNumber ?? EMPTY_SURPLUS_BROKER.licenseNumber;
      });
    case UPDATE_PRODUCER_BROKER:
      return updateProducerBroker(state, 0, (broker) => {
        broker.id = action.payload?.id ?? EMPTY_PRODUCER_BROKER.id;
        broker.name = action.payload?.name ?? EMPTY_PRODUCER_BROKER.name;
        broker.email = action.payload?.email ?? EMPTY_PRODUCER_BROKER.email;
        broker.company =
          action.payload?.company ?? EMPTY_PRODUCER_BROKER.company;
        broker.licenseNumber =
          action.payload?.licenseNumber ?? EMPTY_PRODUCER_BROKER.licenseNumber;
      });
    case UPDATE_WHOLESALE_BROKER:
      return updateWholesaleBroker(state, 0, (broker) => {
        broker.id = action.payload?.id ?? EMPTY_WHOLESALE_BROKER.id;
        broker.name = action.payload?.name ?? EMPTY_WHOLESALE_BROKER.name;
        broker.email = action.payload?.email ?? EMPTY_WHOLESALE_BROKER.email;
        broker.company =
          action.payload?.company ?? EMPTY_WHOLESALE_BROKER.company;
        broker.licenseNumber =
          action.payload?.licenseNumber ?? EMPTY_WHOLESALE_BROKER.licenseNumber;
      });
    case UPDATE_BROKER:
      return updateBroker(state, 0, (broker) => {
        broker.id = action.payload?.id ?? EMPTY_PERSON.id;
        broker.name = action.payload?.name ?? EMPTY_PERSON.name;
        broker.email = action.payload?.email ?? EMPTY_PERSON.email;
        broker.company = action.payload?.company ?? EMPTY_PERSON.company;
      });
    case UPDATE_ASSISTANT:
      return updateAssistant(state, 0, (assistant) => {
        assistant.id = action.payload?.id ?? EMPTY_PERSON.id;
        assistant.name = action.payload?.name ?? EMPTY_PERSON.name;
        assistant.email = action.payload?.email ?? EMPTY_PERSON.email;
        assistant.company = action.payload?.company ?? EMPTY_PERSON.company;
      });
    case UPDATE_PERSON_BY_TYPE:
      return updatePeople(state, 0, action.payload.role, (person) => {
        person.id = action.payload.data?.id ?? EMPTY_PERSON.id;
        person.name = action.payload.data?.name ?? EMPTY_PERSON.name;
        person.email = action.payload.data?.email ?? EMPTY_PERSON.email;
        person.company = action.payload.data?.company ?? EMPTY_PERSON.company;
      });
    case persistenceActionTypes.LOAD_SUBMISSION_STARTED:
      return {
        ...INIT_STATE,
      };
    case persistenceActionTypes.LOAD_SUBMISSION_SUCCEEDED:
      return {
        ...INIT_STATE,
        ...action?.payload?.data?.state?.people,
      };

    default:
      return state;
  }
};

export default peopleReducer;
